var divider_viewer_rtlignore_default = {
  "divider-container": "_1EeuC",
  "divider-container--double": "Dug8T",
  "divider": "NISZK",
  "divider--single": "yOi9j",
  "divider--double": "upPvF",
  "divider--dashed": "_3BoGq",
  "divider--dotted": "ZJOut",
  "divider--small": "Pr1QX",
  "divider--medium": "c44ko",
  "divider--large": "BORuL",
  "divider--left": "XOAFO",
  "divider--center": "Gd6Um",
  "divider--right": "iAMGl",
  "svgFixerContainer": "JzXdH",
  "emptyChar": "L-J8m"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
